import { ICard } from "../../../../interfaces";
import { CardType } from "../../../../util/enums";

const setDilemaCard = (currentDilemmaCardLocal: any, cardType: CardType): ICard => {
     
    if (cardType === CardType.ACTION) { 
        let localCard: ICard = {
            backImagePath: "https://opengameart.org/sites/default/files/card%20back%20red.png",
            content: "Call the facilitator, or start the new game.",
            id: 0,
            title: "Alert",
            type: CardType.QUESTION
        }
    
        if(currentDilemmaCardLocal){
            localCard = {
                backImagePath: "https://opengameart.org/sites/default/files/card%20back%20red.png",
                id: currentDilemmaCardLocal.id,
                content: currentDilemmaCardLocal.description,
                title: currentDilemmaCardLocal.title,
                type: cardType
            }
        }

        return localCard;
    } 

    let localCard: ICard = {
        backImagePath: "https://opengameart.org/sites/default/files/card%20back%20red.png",
        content: "Call the facilitator, or start the new game.",
        id: 0,
        title: "Alert",
        type: CardType.QUESTION
    }

    if(currentDilemmaCardLocal){
        localCard = {
            backImagePath: "https://opengameart.org/sites/default/files/card%20back%20red.png",
            id: currentDilemmaCardLocal.id,
            content: currentDilemmaCardLocal.description,
            title: currentDilemmaCardLocal.title,
            type: cardType
        }
    }

    return localCard;

  };
  
  export default setDilemaCard;
  